'use client'
import Link from 'next/link'
import React from 'react'
import NavigateButton from '../NavigateButton'
import ViewAll from '../ViewAll'
import styles from './styles.module.scss'

interface BottomBarProps {
  linkAddress: string | null
  setPrevSlide?: () => void
  setNextSlide?: () => void
  showNavigationButtons: boolean
  navigationTheme?: 'dark' | 'light'
}

const BottomBar: React.FC<BottomBarProps> = ({
  setPrevSlide,
  setNextSlide,
  linkAddress,
  showNavigationButtons,
  navigationTheme,
}) => {
  return (
    <div className={`${styles.container}`}>
      <div className={styles.buttonWrapper}>
        {showNavigationButtons && (
          <div className={styles.navigationWrapper}>
            <NavigateButton
              direction="prev"
              onClick={() => setPrevSlide && setPrevSlide?.()}
            />
          </div>
        )}

        {linkAddress && (
          <Link href={linkAddress}>
            <ViewAll navigationTheme={navigationTheme} />
          </Link>
        )}

        {showNavigationButtons && (
          <div className={styles.navigationWrapper}>
            <NavigateButton
              direction="next"
              onClick={() => setNextSlide && setNextSlide?.()}
            />
          </div>
        )}
      </div>
    </div>
  )
}
export default React.memo(BottomBar)
